
export default {
  name: 'Loader',
};
